import { render } from "./unggahResepDokter.vue?vue&type=template&id=04e27628&scoped=true"
import script from "./unggahResepDokter.vue?vue&type=script&lang=js"
export * from "./unggahResepDokter.vue?vue&type=script&lang=js"

import "./unggahResepDokter.vue?vue&type=style&index=0&id=04e27628&scoped=true&lang=css"

import exportComponent from "/Users/mymac/Documents/Digitala/Pulih_Anita/frontend-pulih/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e27628"]])

export default __exports__